import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {MarkantDialog, MarkantElementsModule} from '@markant/elements-angular';

@Component({
  selector: 'app-signup-error',
  templateUrl: './signup-error.component.html',
  styleUrls: ['./signup-error.component.scss'],
  standalone: true,
  imports: [MarkantElementsModule],
})
export class SignupErrorComponent implements OnInit {
  @Input() width: number;
  @Input() height: number;
  @ViewChild('SignupError') signupErrorDialog: MarkantDialog;
  @Output() closeEvent = new EventEmitter<boolean>();
  dialogState: boolean;

  ngOnInit() {
    this.dialogState = true;
  }

  close() {
    this.signupErrorDialog.open = false;
    this.closeEvent.emit(false);
  }
}
